import classNames from 'classnames';
import React from 'react';

import svgCardClass, { SvgCardType } from './svg-card-types';

import './svg-card.scss';

interface SvgCardProps {
    type: SvgCardType;
}

const SvgCard = ({ type }: SvgCardProps) => {
    return (
        <div className="svg-card-wrapper">
            <div className={classNames('svg-card-icon', svgCardClass(type))} />
        </div>
    );
};

export default SvgCard;
